import { render, staticRenderFns } from "./caseForm.vue?vue&type=template&id=0f8e07e3&scoped=true"
import script from "./caseForm.vue?vue&type=script&lang=js"
export * from "./caseForm.vue?vue&type=script&lang=js"
import style0 from "./caseForm.vue?vue&type=style&index=0&id=0f8e07e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8e07e3",
  null
  
)

export default component.exports